module.exports = __webpack_public_path__ + "static/media/62 - Caribou - Odessa.2e0ffe91.mp3";